import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=407bfbc1&scoped=true&"
import script from "./base-button.vue?vue&type=script&lang=js&"
export * from "./base-button.vue?vue&type=script&lang=js&"
import style0 from "./base-button.vue?vue&type=style&index=0&id=407bfbc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407bfbc1",
  null
  
)

export default component.exports